define([
	"csi/def/Action",
	"csi/def/ActionFactory",
	"csi/xml"
], function(Action,ActionFactory,xml) {

	return ActionFactory.declare("DisableExpression", Action, {
		// String: default tag for action
		m_tag: "DisableExpression",

		constructor: function(obj) {
			this.setBaseRights(xml.RIGHT_WRITE);
		},

		hasAccess: function(/*Context*/ctx) {
			return xml.nodeAttributeHasFlag(ctx.getNode(), this.heading.m_id, xml.ATTR_FLAG_HAS_EXPRESSION) && this.inherited(arguments);
		}
	});
});